<script setup>
defineProps({
  title: { type: String, required: true },
  description: { type: String, default: '' },
});
</script>

<template>
  <section
    class="flex flex-col gap-4 p-4 min-w-0 rounded-xl shadow sm:px-6 sm:py-5 outline outline-1 outline-n-container bg-n-solid-2"
  >
    <header class="flex flex-wrap gap-2 justify-between items-start">
      <div class="min-w-0">
        <h2 class="text-heading-3 text-n-slate-12">{{ title }}</h2>
        <p v-if="description" class="mt-1 mb-0 text-sm text-n-slate-11">
          {{ description }}
        </p>
      </div>
      <slot name="aside" />
    </header>
    <slot />
  </section>
</template>
